import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { FiChevronLeft, FiEdit, FiFilter, FiPlus, FiTrash, FiX } from 'react-icons/fi';

import { useApiData } from '../../contexts/api-data';

const Exams = ({ history }) => {
    const apiData = useApiData();
    const subjectsMapInitial = {};
    if (apiData.subjects) {
        apiData.subjects.forEach(subject => {
            subjectsMapInitial[subject._id] = {
                subject,
                filtered: true,
            };
        });
    }
    const [subjectsMap, setSubjectsMap] = useState(subjectsMapInitial);
    const [filterFormVisible, setFilterFormVisible] = useState(false);
    const [newSubject, setNewSubject] = useState(false);

    const nameInput = useRef(null);
    const subjectSelect = useRef(null);
    const subjectNameInput = useRef(null);
    const subjectAliasInput = useRef(null);

    async function handleCreateExam() {
        const name = nameInput.current.value;
        const subjectValue = subjectSelect.current.value;
        const newSubject = subjectValue === 'new' ? {
            name: subjectNameInput.current.value,
            alias: subjectAliasInput.current.value,
        } : {};
        const examId = await apiData.newExam(name, subjectValue, newSubject);
        if (examId) {
            history.push(`/dashboard/exams/${examId}`);
        }
    }

    function changeSubjectValue(event) {
        const { value } = event.target;
        if (value === 'new') {
            setNewSubject(true);
        }
        else if (newSubject) {
            setNewSubject(false);
        }
    }

    function toggleFilterForm() {
        setFilterFormVisible(!filterFormVisible);
    }

    function toggleSubjectFiltered(subjectId) {
        const newSubjectsMap = {
            ...subjectsMap,
        };
        newSubjectsMap[subjectId].filtered = !newSubjectsMap[subjectId].filtered;
        setSubjectsMap(newSubjectsMap);
    }

    return (
        <>
            <div className="main-header">
                <Link to="/dashboard" className="header-link"><FiChevronLeft /></Link>
                <h2>Exames</h2>
                <Popup modal trigger={<Link to="#" className="header-link"><FiPlus /></Link>} position="center center">
                    {close => (
                        <div className="modal">
                            <div className="modal-header">
                                <h3>NOVO EXAME</h3>
                                <Link to="#" className="close-button" onClick={close}>
                                    <FiX />
                                </Link>
                            </div>
                            <div className="modal-input-group">
                                <label htmlFor="name">Nome</label>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    ref={nameInput}
                                />
                            </div>
                            <div className="modal-input-group">
                                <label htmlFor="subject">Disciplina</label>
                                <select onChange={changeSubjectValue} ref={subjectSelect}>
                                    <option value="-1">Selecione uma disciplina</option>
                                    {apiData.subjects && apiData.subjects.map(subject => (
                                        <option key={subject._id} value={subject._id}>
                                            {subject.alias || subject.name}
                                        </option>
                                    ))}
                                    <option value="new">Nova disciplina</option>
                                </select>
                                {newSubject && (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="Nome"
                                            ref={subjectNameInput}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Alias"
                                            ref={subjectAliasInput}
                                        />
                                    </>
                                )}
                            </div>
                            <div className="modal-buttons">
                                <button className="cancel-button" onClick={close}>Cancelar</button>
                                <button className="create-button" onClick={handleCreateExam}>Criar</button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>

            {apiData.exams && (
                <ul className="main-content">
                    <li className="main-content-header">
                        <div>Nome</div>
                        <div>Disciplina</div>
                        <div>Última alteração</div>
                        <div className="list-actions">
                            <button
                                className="header-link"
                                onClick={toggleFilterForm}
                            >
                                <FiFilter />
                            </button>
                        </div>
                    </li>
                    {filterFormVisible && apiData.subjects && (
                        <li className="filter-form">
                            {apiData.subjects.map(subject => (
                                <div key={subject._id}>
                                    <input
                                        type="checkbox"
                                        id={`filter-subject-${subject._id}`}
                                        defaultChecked={subjectsMap[subject._id] && subjectsMap[subject._id].filtered}
                                        onChange={() => toggleSubjectFiltered(subject._id)}
                                    />
                                    <label htmlFor={`filter-subject-${subject._id}`}>
                                        {subject.name}
                                    </label>
                                </div>
                            ))}
                        </li>
                    )}
                    {apiData.exams.map((exam, index) => {
                        const subjectFilter = subjectsMap[exam.subject];
                        const { filtered } = {
                            filtered: true,
                            ...subjectFilter,
                        };
                        let examSubject;
                        if (subjectFilter) {
                            const { alias, name } = subjectFilter.subject;
                            examSubject = alias || name;
                        }
                        return filtered && (
                            <li key={exam._id}>
                                <span>{exam.name}</span>
                                <span>{examSubject || exam.subject}</span>
                                <span>{new Intl.DateTimeFormat('pt-BR').format(new Date(exam.updatedAt))}</span>
                                <Link
                                    className="header-link"
                                    to={`/dashboard/exams/${exam._id}`}
                                >
                                    <FiEdit />
                                </Link>
                                <button
                                    className="header-link"
                                    onClick={() => apiData.removeExam(index)}
                                >
                                    <FiTrash />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
}

export default Exams;
